export const inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);

export const isDev = process.env.NODE_ENV === 'development';

export const range = (number) => [...Array(number).keys()];

export const formatToggleLabelWithAdditionalFields = ({ label, index }) =>
  `${label}${index > 0 ? ` #${index + 1}` : ''}`;
